import request from '@/utils/request'

export const getCompanyInfo = id =>
  request.get(`/customer-api/customer/overview/${id}`)

export const getChartData = params =>
  request.post('/customer-api/credit-trend/statistics', params)

// 获取css详情
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)
